import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./Admin.css";
import { IoIosAddCircleOutline } from "react-icons/io";
import { CiViewList } from "react-icons/ci";
import { useState } from "react";
import { FaHouse } from "react-icons/fa6";







function Admin() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="admin-layout">

            <div className="admin-topbar">
                <button onClick={() => setMenuOpen(!menuOpen)} className="hamburger">
                    ☰
                </button>
                <span>Admin</span>
            </div>

            <div className={`admin-sidebar ${menuOpen ? "open" : ""}`}>
                <NavLink
                    to="/admin-dodajaj"
                    className="nav-item nav-item-adm"
                    onClick={() => setMenuOpen(false)}
                >
                    <FaHouse /> Admin
                </NavLink>

                <NavLink
                    to="/admin-dodajaj/dodaj-koncerte"
                    className="nav-item"
                    onClick={() => setMenuOpen(false)}
                >
                    <IoIosAddCircleOutline /> Koncerti
                </NavLink>


                <NavLink
                    to="/admin-dodajaj/dodaj-novice"
                    className="nav-item"
                    onClick={() => setMenuOpen(false)}
                >
                    <IoIosAddCircleOutline /> Novice
                </NavLink>

                <NavLink
                    to="/admin-dodajaj/pregled-rezervacij"
                    className="nav-item"
                    onClick={() => setMenuOpen(false)}
                >
                    <CiViewList /> Rezervacije
                </NavLink>

                <NavLink
                    to="/admin-dodajaj/pregled-abonentov"
                    className="nav-item"
                    onClick={() => setMenuOpen(false)}
                >
                    <CiViewList /> Abonenti
                </NavLink>
            </div>


            <div className="admin-content">
                <Outlet />
            </div>

        </div>
    );
}

export default Admin;